export enum SituacaoCaixa {
  ABERTO = 'ABERTO',
  FECHADO = 'FECHADO',
  PENDENTE = 'PENDENTE',
  LIBERADO = 'LIBERADO',
}
